module.exports = __webpack_public_path__ + "img/29.21598fc1.jpg";